export const userLocalSessionKey="mdm_org_user";
export const userDefOrgLocalStorageKey="mdm_usr_default_org";